const COLOR_RANGE_LIST = {
  GREEN: "var(--green-case)",
  YELLOW: "var(--warning-surface)",
  RED: "var(--red-case)",
  BLUE: "var(--blue-case)",
  GRAY: "var(--gray-case)",
  CRITICAL: "var(--critical-case)",
} as const

type ColorRange = (typeof COLOR_RANGE_LIST)[keyof typeof COLOR_RANGE_LIST]

export { COLOR_RANGE_LIST, type ColorRange }
